import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./AppointmentBooking.css";
import { useDispatch, useSelector } from "react-redux";
import { createAppointment, getCalendarEvents } from "../../appState/slices/appointment/appointmentSlice";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
import { useNavigate } from "react-router-dom";

const AppointmentBooking = () => {

    const [date, setDate] = useState(null);
    const [time, setTime] = useState("");
    const [purpose, setPurpose] = useState("");
    const [calendarOpen, setCalendarOpen] = useState(false);

    const appointments = useSelector((state) => state.appointment.appointments);
    const blockedDates = useSelector((state) => state.appointment.blockedDates);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const slots = ["10:30", "11:30", "12:30", "14:30", "15:30", "16:30"];

    useEffect(() => {
        dispatch(getCalendarEvents());
    }, [dispatch]);

    useEffect(() => {

        const handleClickOutside = (e) => {
            if (e.target.classList.contains("calendar-modal")) {
                setCalendarOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };

    }, []);

    /* ----------------------------------
       FORMAT DATE
    ----------------------------------- */

    const formatDate = (dateObj) => {
        return (
            dateObj.getFullYear() +
            "-" +
            String(dateObj.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(dateObj.getDate()).padStart(2, "0")
        );
    };

    /* ----------------------------------
       CHECK SLOT FULL
    ----------------------------------- */

    const isSlotFull = (slot) => {

        if (!date) return false;

        const formatted = formatDate(date);

        const count = (appointments || []).filter(
            (a) => a.date === formatted && a.time === slot
        ).length;

        return count >= 2;
    };

    /* ----------------------------------
       BOOK APPOINTMENT
    ----------------------------------- */

    const handleBooking = async () => {

        if (!date || !time) {
            alert("Please select date and time");
            return;
        }

        if (isSlotFull(time)) {
            dispatch(setToastMessage({
                type: "error",
                message: "This slot was just booked. Please select another time.",
                show: true,
            }));
            return;
        }

        try {

            const booking = {
                date: formatDate(date),
                time,
                purpose
            };

            await dispatch(createAppointment(booking));

            dispatch(setToastMessage({
                type: "success",
                message: "Appointment Created Successfully",
                show: true,
            }));

            setDate(null);
            setTime("");
            setPurpose("");

            dispatch(getCalendarEvents());

        } catch (error) {

            dispatch(setToastMessage({
                type: "error",
                message: "Error creating Appointment",
                show: true,
            }));

        }

    };

    return (
        <>

            <div className="appointment-page">

                {/* LEFT IMAGE */}

                <div className="appointment-image">
                    <img
                        src="https://purecarats-prod.s3.ap-south-1.amazonaws.com/Purecarats+-+Bracelet+and+Ring.png"
                        alt="PureCarat Consultation"
                    />
                </div>

                {/* RIGHT FORM */}

                <div className="appointment-form">

                    <div className="appointment-header">

                        <button
                            className="my-appointments-btn"
                            onClick={() => navigate("/myappointments")}
                        >
                            View My Appointments
                        </button>
                        <h1>Private Jewellery Consultation</h1>

                        <p>
                            Visit our studio for a personal jewellery consultation.
                            Our specialists will guide you through our diamond collection.
                        </p>

                        <div className="studio-address">
                            DREAMS JEWELS
                            <br />
                            713, Kosha Kommercial Komplex,
                            <br />
                            Poddar Rd, Malad East, Mumbai
                            <br />
                            By appointment only
                        </div>

                    </div>

                    {/* DATE */}

                    <div className="booking-block">

                        <div className="block-title">
                            Select Date
                        </div>

                        <div
                            className="date-input"
                            onClick={() => setCalendarOpen(true)}
                        >
                            {date ? date.toDateString() : "Choose a date"}
                        </div>

                    </div>

                    {/* TIME */}

                    <div className="booking-block">

                        <div className="block-title">
                            Select Time
                        </div>

                        <div className={`time-grid ${!date ? "disabled-grid" : ""}`}>
                            {slots.map((slot) => {

                                const full = isSlotFull(slot);

                                return (

                                    <button
                                        key={slot}
                                        disabled={!date || full}
                                        className={`time-slot 
                      ${time === slot ? "active" : ""}
                      ${full ? "disabled-slot" : ""}
                    `}
                                        onClick={() => setTime(slot)}
                                    >

                                        {full ? "Full" : slot}

                                    </button>

                                );

                            })}

                        </div>

                    </div>

                    {/* PURPOSE */}

                    <div className="booking-block">

                        <div className="block-title">
                            Purpose
                        </div>

                        <select
                            className="purpose-input"
                            value={purpose}
                            onChange={(e) => setPurpose(e.target.value)}
                        >

                            <option value="">Select</option>
                            <option>Diamond Viewing</option>
                            <option>Custom Jewellery Design</option>
                            <option>Engagement Ring Consultation</option>
                            <option>Wedding Jewellery</option>

                        </select>

                    </div>

                    <button
                        className="book-btn"
                        onClick={handleBooking}
                    >
                        Book Appointment
                    </button>

                </div>

            </div>

            {/* CALENDAR MODAL */}

            {calendarOpen && (

                <div className="calendar-modal">

                    <div className="calendar-container">

                        <div className="calendar-header">

                            <span>Select Date</span>

                            <button
                                className="calendar-close"
                                onClick={() => setCalendarOpen(false)}
                            >
                                ✕
                            </button>

                        </div>

                        <DatePicker
                            inline
                            selected={date}
                            onChange={(d) => {
                                setDate(d);
                                setCalendarOpen(false);
                            }}
                            minDate={new Date()}
                            filterDate={(d) => {

                                const formatted =
                                    d.getFullYear() +
                                    "-" +
                                    String(d.getMonth() + 1).padStart(2, "0") +
                                    "-" +
                                    String(d.getDate()).padStart(2, "0");

                                const blocked = (blockedDates || []).some(
                                    (b) => b.date === formatted
                                );

                                return d.getDay() !== 0 && !blocked;
                            }}
                        />

                    </div>

                </div>

            )}

        </>
    );
};

export default AppointmentBooking;